import { createSelector } from 'reselect';

export const publishSelector = (state) => state.publish;
export const addressesSelector = createSelector(publishSelector, (publish) => publish.addresses);
export const creditsSelector = createSelector(publishSelector, (publish) => publish.credits);
export const preflightSelector = createSelector(publishSelector, (publish) => publish.preflight);
export const countriesSelector = createSelector(publishSelector, (publish) => publish.countries);
export const statesSelector = createSelector(publishSelector, (publish) => publish.states);
export const orderSelector = createSelector(publishSelector, (publish) => publish.order);
